import type { Metadata } from "next";
import AdminInfluencerDetail from "@/Component/Admin/AdminInfluencersListing/AdminInfluencerDetail";

export const metadata: Metadata = {
    title: "Influencer Details | Connector Club",
    description: "",
};

const AdminInfluencerDetailsPage = async ({ params }: { params: Promise<{ UserSlug: string }>; }) => {
    const resolvedParams = await params;
    const userSlug = Array.isArray(resolvedParams.UserSlug)
        ? resolvedParams.UserSlug[0]
        : resolvedParams.UserSlug;
    
    return <AdminInfluencerDetail userSlug={userSlug} />;
};

export default AdminInfluencerDetailsPage;
